import React, { useEffect, useState } from 'react'
import { Typography, Box } from '@mui/material'
import Skeleton from 'react-loading-skeleton'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
import { LineChart } from '@mui/x-charts'

function CustomersChart() {
    const [loading, setLoading] = useState(true)
    const [chartData, setChartData] = useState([])

    useEffect(() => {
        Api.get('customers/chart')
            .then(res => {
                if (res.data && res.data.success) {
                    setChartData(res.data.data)
                }
                setLoading(false)
            })
            .catch(() => setLoading(false))
    }, [])

    const labels = chartData.map(d => d.label)
    const counts = chartData.map(d => d.count)

    function getIfAnyCustomers() {
        return chartData.some(
            (item) => item.count > 0
        )
    }

    return (
        <div className='customers-chart'>
            <div className='head'>
                <h3>
                    {trans('labels.addedCustomers')}
                </h3>
            </div>
            <hr />
            {loading ?
                <Skeleton height={300} count={1} /> :
                !getIfAnyCustomers() ?
                    <div
                        className="alert info"
                        style={{
                            marginBottom: 0,
                            width: "100%",
                        }}
                    >
                        {trans("messages.noDataFound")}
                    </div>
                    :
                    <LineChart
                        xAxis={[{
                            data: labels,
                            scaleType: 'point',
                        }]}
                        series={[{
                            data: counts,
                            area: true,
                            color: '#4A3AFF',
                            showMark: true,
                        }]}
                        height={287}
                        // margin={{ left: 50, right: 20, top: 20, bottom: 30 }}
                        grid={{ horizontal: true }}
                        sx={{
                            '& .MuiAreaElement-root': {
                                fill: 'url(#customers-gradient)',
                            },
                            '& .MuiLineElement-root': {
                                strokeWidth: 1,
                            },
                            '& .MuiMarkElement-root': {
                                stroke: '#fff',
                                strokeWidth: 1,
                                fill: '#4A3AFF',
                                r: 5,
                            },
                            '& .MuiChartsGrid-line': {
                                stroke: '#e0e0e0',
                                strokeDasharray: '4 2',
                            },
                        }}
                    >
                        <defs>
                            <linearGradient id="customers-gradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#4A3AFF" stopOpacity={0.25} />
                                <stop offset="100%" stopColor="#4A3AFF" stopOpacity={0.02} />
                            </linearGradient>
                        </defs>
                    </LineChart>
            }
        </div>
    )
}

export default CustomersChart
